import { useTranslation } from 'react-i18next';

type QrLoaderProps = {
  /** Ключ подписи под спиннером; без него — только кольцо. */
  labelKey?: string;
};

/**
 * Загрузка кода в карточке QR: кольцо в фирменном зелёном на бледной
 * дорожке и подпись под ним. Занимает ту же карточку, что и сам код, чтобы
 * при появлении кода ничего не прыгало.
 */
export const QrLoader = ({ labelKey }: QrLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-col items-center justify-center gap-5"
    >
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        aria-hidden
        className="animate-spin [animation-duration:900ms]"
      >
        {/* Дорожка */}
        <circle
          cx="28"
          cy="28"
          r="24"
          stroke="currentColor"
          strokeWidth="4"
          opacity="0.15"
          className="text-brand-green"
        />
        {/* Бегущая дуга — четверть окружности со скруглёнными концами */}
        <circle
          cx="28"
          cy="28"
          r="24"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="40 111"
          className="text-brand-green"
        />
      </svg>
      {labelKey && (
        <p className="text-center text-body-sm-regular text-text-secondary">
          {t(labelKey)}
        </p>
      )}
    </div>
  );
};
